<template>
  <v-delete-dialog
    :visivel="visivel"
    tipo="confirma"
    mensagem="Excluir sala"
    corpoMensagem="Tem certeza que deseja excluir esta sala?"
    @close="$emit('close')"
    @confirma="$emit('confirma')" />
</template>

<script>
import VDeleteDialog from "@/components/dialogs/VDeleteDialog"

export default {
  name: "v-delele-sala-dialog",
  components: { VDeleteDialog },
  props: {
    visivel: {
      type: Boolean,
    },
  },
}
</script>
